<app-dialog-heading [heading]="heading"></app-dialog-heading>

<mat-dialog-actions align="center" class="dialog-button-container">

  <button class="dialog-button-fit-content" mat-raised-button color="primary" (click)="onContinueClick()">
    <mat-icon>keyboard_backspace</mat-icon>
    Continue
  </button>

  <button class="dialog-button-fit-content" mat-raised-button color="primary" (click)="onReviewClick()">
    <mat-icon>edit</mat-icon>
    Review {{this.claimType}}
  </button>

  <button class="dialog-button-fit-content" mat-raised-button color="primary"
          (click)="onGenerateClick($event)">
    <mat-icon>download</mat-icon>
    Generate Report
    <app-busy-spinner-icon [isBusyCounter]="isBusyCounterInlineSpinner"></app-busy-spinner-icon>
  </button>

  <button *ngIf="jiraEnabled && jiraKeyExists" class="dialog-button-fit-content" mat-raised-button color="primary"
          (click)="onJiraClick()">
    <img src="../../../../../../assets/jira-service-management-logo.svg"
         alt="Jira Service Management Logo"
         class="jira-logo">
    Open Jira Issue
  </button>
</mat-dialog-actions>

<div style="text-align: center; max-width: 80vw; max-height: 70vh;">
  <mat-form-field style="width: 20vw;">
    <mat-label>Drill Down Into Activity</mat-label>
    <mat-select (selectionChange)="activitySelected($event.source.value)" [formControl]="activityFormControl">
      <mat-option *ngFor="let id of activityIds" [value]="id">
        {{id}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <br>
  <button *ngIf="showActivityDrillDown" (click)="backToTransactionResults()" mat-button
          class="dialog-button-fit-content">
    <mat-icon style="color: grey;">keyboard_backspace</mat-icon>
    Back to Transaction Results
  </button>

  <div [innerHTML]="html"></div>
</div>

